export default defineNuxtPlugin(async () => {
  // 只在客户端运行
  if (process.server) return

  // 检查当前路由是否在 Chat 目录下
  const router = useRouter()
  const route = useRoute()

  // 如果当前路由不是以 /chat 开头，则不执行数据库初始化
  if (!route.path.toLowerCase().startsWith('/chat')) {
    return
  }

  // 性能测量工具
  const createPluginPerformanceMeasure = (name: string) => {
    const startTime = performance.now()
    return {
      end: () => {
        const endTime = performance.now()
        const duration = endTime - startTime
        console.log(`🔌 插件性能 [${name}]: ${duration.toFixed(2)}ms`)
        return duration
      }
    }
  }

  const pluginMeasure = createPluginPerformanceMeasure('数据库插件初始化')

  try {
    console.log('🚀 开始数据库插件初始化')

    // 初始化数据库
    const database = useDatabase()
    await database.initDatabase()

    pluginMeasure.end()
    console.log('✅ 数据库插件初始化成功')
  } catch (error) {
    pluginMeasure.end()
    console.error('❌ 数据库插件初始化失败:', error)

    // 可以考虑降级到内存模式或显示用户友好的错误信息
    throw error
  }
})